import React from 'react';
import { computeEventStatus } from '../../utils/eventStatus';

/**
 * DataGrid Status kolonu — computeEventStatus ile tek mantik.
 */
const EventStatusCell = ({ event, endedLabel }) => {
  const { label, bgColor, color } = computeEventStatus(event, { endedLabel });

  return (
    <div
      style={{
        backgroundColor: bgColor,
        color,
        textAlign: 'center',
        borderRadius: 5,
        padding: '3px 6px',
        width: '100%',
      }}
    >
      <span>{label}</span>
    </div>
  );
};

export default EventStatusCell;
